<template>
  <q-input
    :type="isVisible ? 'text' : 'password'"
    name="password"
    :model-value="modelValue"
    v-bind="$attrs"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template v-slot:append>
      <q-btn
        :label="isVisible ? 'Hide' : 'View'"
        :title="isVisible ? 'Hide Password' : 'View Password'"
        no-caps
        flat
        @click="isVisible = !isVisible"
      />
    </template>
  </q-input>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

interface Data {
  isVisible: boolean
}

export default defineComponent({
  emits: ['update:modelValue'],
  props: {
    modelValue: String,
  },
  data(): Data {
    return {
      isVisible: false,
    };
  },
});
</script>
